import { Button, Toggle } from "@jutro/ui";
import { Controller, useForm } from "react-hook-form";
import {
  EdmGetAllStaffWithGenreAndWorkingHoursDocument,
  EdmMedicalPerson,
  useEdmUpdateDeclarationsMutation,
} from "lib/graphql/megaSchema";
import { toaster } from "lib/tools/toaster";

type Props = {
  selectedStaff: EdmMedicalPerson;
};

export const DeclarationForm = ({ selectedStaff }: Props) => {
  const defaultValues = {
    adultDeclarable: selectedStaff.adultDeclarable,
    childrenDeclarable: selectedStaff.childrenDeclarable,
  };

  const {
    control,
    formState: { isDirty },
    reset,
    handleSubmit,
  } = useForm({
    defaultValues,
  });

  const [updateDeclarations, { loading }] = useEdmUpdateDeclarationsMutation({
    refetchQueries: [EdmGetAllStaffWithGenreAndWorkingHoursDocument]
  });

  const onSubmit = async (input: typeof defaultValues) => {
    if (!isDirty) {
      return;
    }

    await toaster.promise(
      updateDeclarations({
        variables: { staffId: selectedStaff.id, input },
      }),
      {
        error: "Nie udało się zaktualizować ustawień deklaracji",
        loading: "Aktualizuję ustawienia deklaracji",
        success: "Zaktualizowano ustawienia deklaracji",
      },
    );

    reset(input);
  };

  return (
    <div className="flex flex-col gap-8 p-4">
      <form className="flex flex-col gap-6">
        <Controller
          control={control}
          name="adultDeclarable"
          render={({ field: { value, onChange } }) => (
            <Toggle
              label="Deklaruje dorosłych"
              isEnabled={value}
              setIsEnabled={onChange}
            />
          )}
        />

        <Controller
          control={control}
          name="childrenDeclarable"
          render={({ field: { value, onChange } }) => (
            <Toggle
              label="Deklaruje dzieci"
              isEnabled={value}
              setIsEnabled={onChange}
            />
          )}
        />
      </form>

      <div className="flex justify-end gap-2">
        <Button
          type="button"
          variant="secondary"
          text="Anuluj"
          full={false}
          disabled={loading}
          onClick={() => reset(defaultValues)}
        />

        <Button
          type="button"
          variant="primary"
          text="Zapisz"
          full={false}
          loading={loading}
          onClick={handleSubmit((data) => onSubmit(data))}
        />
      </div>
    </div>
  );
};
